document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".application-videos");
  if (!section) return; // safety check
  
  // Swiper Init only inside this section
  const swiper = new Swiper(section.querySelector(".appVideoSwiper"), {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: section.querySelector(".pagination_swiper"),
      clickable: true,
    },
    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 12 },
      768: { slidesPerView: 2, spaceBetween: 20 },
    },
  });

  // Popup Script (Scoped)
  const videoCards = section.querySelectorAll(".video-card");
  const popup = document.getElementById("videoPopup");
  const videoFrame = document.getElementById("videoFrame");
  const closePopup = popup.querySelector(".close-popup");

  videoCards.forEach(card => {
    const playBtn = card.querySelector(".play-btn");
    playBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      const videoUrl = card.getAttribute("data-video") + "?autoplay=1";
      videoFrame.src = videoUrl;
      popup.style.display = "flex";
    });
  });

  closePopup.addEventListener("click", () => {
    popup.style.display = "none";
    videoFrame.src = "";
  });

  window.addEventListener("click", e => {
    if (e.target === popup) {
      popup.style.display = "none";
      videoFrame.src = "";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".application-videos");
  if (!section) return; // safety check
  
  // Swiper Init only inside this section
  const swiper = new Swiper(section.querySelector(".appVideoSwiper"), {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: section.querySelector(".pagination_swiper"),
      clickable: true,
    },
    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 12 },
      768: { slidesPerView: 2, spaceBetween: 20 },
    },
  });
  
  // Popup Script (Scoped with unique IDs)
  const videoCards = section.querySelectorAll(".video-card");
  const popup = document.getElementById("videoPopupApp");
  const videoFrame = document.getElementById("videoFrameApp");
  const closePopup = document.querySelector(".close-popup-app");
  
  videoCards.forEach(card => {
    const playBtn = card.querySelector(".play-btn");
    playBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      const videoUrl = card.getAttribute("data-video") + "?autoplay=1";
      videoFrame.src = videoUrl;
      popup.style.display = "flex";
    });
  });
  
  closePopup.addEventListener("click", () => {
    popup.style.display = "none";
    videoFrame.src = "";
  });
  
  window.addEventListener("click", e => {
    if (e.target === popup) {
      popup.style.display = "none";
      videoFrame.src = "";
    }
  });
});


            var swiperabout = new Swiper(".mySwiper-about", {
            slidesPerView: 1,
            spaceBetween: 20,
             loop: true,
            pagination: {
                el: ".swiper-pagination-about",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next-about",
                prevEl: ".swiper-button-prev-about",
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 3,
                },
            },
        });